<div class="flex flex-row w-full gap-0 p-0 place-items-center">
    <mat-icon
        class="w-7 h-7 rounded-full"
        [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <div class="flex flex-col w-full gap-2 p-3">
        <div *ngIf="this.auditData?.createdOn && this.auditData.createdBy && ( expanded || !(this.auditData?.updatedOn && this.auditData.updatedBy))" class="flex items-center">
            <div class="flex flex-col text-md">
                <div><b>{{'Created by' | transloco }}:</b> {{auditData.createdBy}}</div>
                <div class="text-sm text-secondary leading-none">{{auditData.createdOnStr}}</div>
            </div>
        </div>

        <div *ngIf="this.auditData?.updatedOn && this.auditData.updatedBy" class="flex items-center">
            <div class="flex flex-col text-md">
                <div><b>{{'Updated by' | transloco }}:</b> {{auditData.updatedBy}}</div>
                <div class="text-sm text-secondary leading-none">{{auditData.updatedOnStr}}</div>
            </div>
        </div>
    </div>

    <button *ngIf="this.auditData?.updatedOn && this.auditData.updatedBy && this.auditData?.createdOn && this.auditData.createdBy"
        class="relative top-0 right-2"
        mat-icon-button
        (click)="expanded = !expanded">
        <mat-icon *ngIf="!expanded"
            class="text-current icon-size-4"
            [svgIcon]="'heroicons_outline:chevron-down'"></mat-icon>

        <mat-icon *ngIf="expanded"
                  class="text-current icon-size-4"
                  [svgIcon]="'heroicons_outline:chevron-up'"></mat-icon>
    </button>

</div>
